<template>
  <div class="local-ads local-ads--halfpage">
    <a
      v-if="props.payload?.link && props.payload?.imageUrl"
      :href="props.payload?.link"
      :target="props.payload?.target || '_blank'"
    >
      <img
        :src="props.payload?.imageUrl"
        :srcset="props.payload?.imageSet"
        :alt="$t('advertisement.alt')"
      />
    </a>
    <img
      v-else-if="props.payload?.imageUrl"
      :src="props.payload?.imageUrl"
      :srcset="props.payload?.imageSet"
      :alt="$t('advertisement.alt')"
    />
  </div>
</template>
<script setup lang="ts">
import type {PropType} from "vue";
import type CncAdPosition from "~/libs/interfaces/CncAdPosition"

const props = defineProps({
  payload: {type: Object as PropType<CncAdPosition>, required: false}
})
</script>